import script from "./interview.vue?vue&type=script&lang=ts&setup=true"
export * from "./interview.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__